import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';

import { Title } from 'src/onboarding/components/typography/Title/Title';

import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const goalMotivation = useStore((state) => state.goalMotivation);
  const setGoalMotivation = useStore((state) => state.setGoalMotivation);
  const { onNext, onPrev, currentIndex } = useNav();


  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.goalMotivation.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={goalMotivation}
          onChange={(value) => {
            setGoalMotivation(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'goal-motivation',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={"Living a healthier and more energetic life"}>
            <span>💫</span> {t('onboarding.goalMotivation.options.living')}
          </Option>
          <Option value={"Feeling confident and proud"}>
            <span>💪</span> {t('onboarding.goalMotivation.options.feeling')}
          </Option>
          <Option value={"Being able to wear clothes I love"}>
            <span>👗</span> {t('onboarding.goalMotivation.options.beingAble')}
          </Option>
          <Option value={"Seeing the difference in my body size"}>
            <span>🔍</span> {t('onboarding.goalMotivation.options.seeing')}
          </Option>
          <Option value={"Being in my best physical shape"}>
            <span>🏋️</span> {t('onboarding.goalMotivation.options.beingBest')}
          </Option>
          <Option value={"Other"}>
            <span>❓</span> {t('onboarding.goalMotivation.options.other')}
          </Option>
        </Check>
      </div>
    </div>
  );
}

export default Page;
